import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Spin, message } from "antd";
import { useMerchant } from "context/merchantContext";

const MerchantImpersonate = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { setPermissions } = useMerchant();

  useEffect(() => {
    const token = searchParams.get("token");
    const merchantId = searchParams.get("merchantId");
    const merchantData = searchParams.get("merchantData");

    if (!token || !merchantId) {
      message.error("Хандах эрхгүй байна.");
      navigate("/");
      return;
    }

    try {
      const parsedData = merchantData ? JSON.parse(decodeURIComponent(merchantData)) : {};

      // Store in sessionStorage (tab-isolated — does not affect admin's localStorage)
      sessionStorage.setItem("merchantToken", token);
      sessionStorage.setItem("merchantId", merchantId);
      sessionStorage.setItem("merchantData", JSON.stringify(parsedData));
      sessionStorage.setItem("isImpersonation", "true");

      if (parsedData.permissions) {
        setPermissions(parsedData.permissions.map((e) => e.id));
      }

      navigate("/merchantDashboard");
    } catch {
      message.error("Токен боловсруулахад алдаа гарлаа.");
      navigate("/");
    }
  }, []);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <Spin size="large" tip="Нэвтэрч байна..." />
    </div>
  );
};

export default MerchantImpersonate;
